import { toast } from 'react-toastify';
import _ from 'lodash';
import { translate } from 'core/utils';

class NotificationStore {
	constructor(rootStore) {
		this.rootStore = rootStore;
		this.messages = [];
	}

	load = loadingMessage => {
		const id = toast.loading(loadingMessage);
		return id;
	};

	dismiss = id => {
		toast.dismiss(id);
	};

	pull() {
		_.each(this.messages, messageProps => {
			toast(messageProps[0], messageProps[1]);
		});
		this.messages = [];
	}

	success(message, push = false, options = null) {
		if (!push) {
			toast.success(translate(message), options);
		} else {
			this.messages.push([translate(message), { type: toast.TYPE.SUCCESS }]);
		}
	}

	warning(message, optionsOrPush = false, options = null) {
		if (typeof optionsOrPush === 'boolean') {
			if (!optionsOrPush) {
				toast.warn(translate(message), options);
			} else {
				this.messages.push([translate(message), { type: toast.TYPE.WARNING }]);
			}
		} else {
			toast.warn(translate(message), optionsOrPush);
		}
	}

	error(message, push = false, options = null) {
		if (!push) {
			toast.error(translate(message), options);
		} else {
			this.messages.push([translate(message), { type: toast.TYPE.ERROR }]);
		}
	}
}

export default NotificationStore;
